import React from 'react';
export function Footer() {
  return <footer className="bg-brand-dark text-gray-500 py-4 px-3 border-t border-brand-accent/10" data-id="element-62">
      <div className="max-w-2xl mx-auto flex flex-col items-center text-center" data-id="element-63">
        <div className="w-full text-[9px] md:text-[10px] text-gray-500 font-normal leading-relaxed" data-id="element-64">
          <p data-id="element-65">© 2025 Kit Programación Lista — Todos los derechos reservados.</p>
          <p className="mt-0.5" data-id="element-66">
            Material desarrollado por docentes de secundaria técnica para
            docentes de secundaria técnica.
          </p>
        </div>
      </div>
    </footer>;
}